export enum SUBSCRIPTION_PLANS {
  monthly = 'Monthly subscription',
  monthlyVariation = 'Subscribe and save',
  quarterly = 'Quarterly subscription',
  single = 'Single purchase',
  oneOff = 'One off',
}
